import Feedback from '@/components/Feedback/Feedback';
import RememberScrollPositionContext from '@/context/RememberScrollPositionContext';
import useCollections from '@/hooks/collections/useCollections';
import { useContext, useEffect, useRef } from 'react';
import Collection from './Collection/Collection';

const Collections = () => {
	const listRef = useRef<HTMLOListElement>(null);
	const rememberScrollPosition = useContext(RememberScrollPositionContext);

	const { collectionsSortedByCollectedCards } = useCollections();

	// If there is no scroll position with key tab-collections, scroll top of list in view
	useEffect(() => {
		if (rememberScrollPosition.get('tab-collections') ?? 0 > 0) return;

		if (listRef.current) {
			listRef.current.scrollIntoView({
				behavior: 'instant',
				block: 'start',
				inline: 'start',
			});
		}
	}, [listRef, rememberScrollPosition]);

	return (
		<main className="min-h-screen">
			<Feedback />
			<ol
				ref={listRef}
				aria-label="Kwartetten"
				className="grid min-h-screen gap-4 pt-24">
				{collectionsSortedByCollectedCards.map((collection) => (
					<Collection key={collection.id} collection={collection} />
				))}
			</ol>
		</main>
	);
};

export default Collections;
